<div class="flex-container">
  <div nz-col nzSpan="6" class="page-content--left" *hwPrivileged="viewPrivileges">
    <form class="filter-form" nz-form (ngSubmit)="query.offset = 0; loadDefinitions()">
      <div class="filter-form__header sticky">
        <button
          class="button float-left"
          nz-button
          nzType="secondary"
          type="button"
          (click)="query = initialParams(); loadDefinitions()">
          {{ 'mdm.obs-def-01.form.reset' | translate }}
        </button>
        <button class="button float-right" nz-button nzType="primary" type="submit">
          {{ 'mdm.obs-def-01.form.search' | translate }}
        </button>
      </div>

      <div class="filter-form__body">
        <hw-panel-form-item label="mdm.obs-def-01.form.text">
          <input nz-input [(ngModel)]="search" name="text" />
        </hw-panel-form-item>
        <hw-panel-form-item label="mdm.obs-def-01.form.date">
          <hw-date-picker [(ngModel)]="query.date" name="date"></hw-date-picker>
        </hw-panel-form-item>
      </div>
    </form>
  </div>

  <nz-content class="page-content--header-inside">
    <hw-page-header class="page-header" header="mdm.obs-def-01.header">
      <div class="content float-right" *hwPrivileged="viewPrivileges">
        <button class="button" [routerLink]="['add']" nz-button nzType="secondary" *hwPrivileged="editPrivileges">
          {{ 'core.btn.add-new' | translate }}
        </button>
        <button
          class="button"
          nz-button
          nzType="secondary"
          (click)="importObservationDefinition()"
          *hwPrivileged="editPrivileges">
          {{ 'mdm.obs-def-01.import' | translate }}
        </button>
        <input #importDefinitionInp [hidden]="true" type="file" (change)="readFile($event)" />
      </div>
    </hw-page-header>

    <div class="page-content__flex-cols-container" *hwPrivileged="viewPrivileges">
      <hw-backend-table
        nz-col
        nzSpan="24"
        [result]="definitions"
        [query]="query"
        [loading]="loading"
        (dataChange)="loadDefinitions()">
        <hw-backend-column title="mdm.obs-def-01.list.code" sort="code">
          <ng-template #cellTemplate let-item>
            <a [routerLink]="['edit', item.id]">{{ item.code }}</a>
          </ng-template>
        </hw-backend-column>

        <hw-backend-column title="mdm.obs-def-01.list.type">
          <ng-template #cellTemplate let-item>
            {{ item.type?.code }}
          </ng-template>
        </hw-backend-column>

        <hw-backend-column title="mdm.obs-def-01.list.category">
          <ng-template #cellTemplate let-item>
            {{ item.category?.code }}
          </ng-template>
        </hw-backend-column>

        <hw-backend-column title="mdm.obs-def-01.list.name" [sort]="'name|' + translateService.currentLang">
          <ng-template #cellTemplate let-item>
            {{ item.names | localName }}
          </ng-template>
        </hw-backend-column>

        <hw-backend-column title="mdm.obs-def-01.list.data-type">
          <ng-template #cellTemplate let-item>
            {{ item.dataType?.code }}
          </ng-template>
        </hw-backend-column>

        <hw-backend-column title="mdm.obs-def-01.list.period">
          <ng-template #cellTemplate let-item>
            {{ item.period?.lower | localDate }} - {{ item.period?.upper | localDate }}
          </ng-template>
        </hw-backend-column>
      </hw-backend-table>
    </div>
  </nz-content>
</div>
